import { render, staticRenderFns } from "./activityAdapterFile.vue?vue&type=template&id=6963ab31&scoped=true"
import script from "./activityAdapterFile.vue?vue&type=script&lang=js"
export * from "./activityAdapterFile.vue?vue&type=script&lang=js"
import style0 from "./activityAdapterFile.vue?vue&type=style&index=0&id=6963ab31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963ab31",
  null
  
)

export default component.exports